<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Edit Account Type'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


      @if (loaded) {
        <tidy-card>
          <tidy-row>
            <tidy-text
              [body]="'What are you using TIDY for?'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-radio-button
              formControlName="type"
              [form]="form.controls.type"
              [items]="accountTypes" />
          </tidy-row>
      </tidy-card>
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
      <tidy-button
        [text]="'Save Account Type'"
        [action]="boundSave"
        class="primary" />
    }

  </tidy-wrapper>
</form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
